import { FilterField, FilterOption } from '../models/filter-option.model';

const opt = (values: Array<string>): Array<FilterOption> =>
  values.map((v) => ({ value: v, label: v }));

export const ANIOS = opt(['2026', '2025']);

export const MESES = opt([
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
]);

export const TIPOS_CLIENTE = opt(['Comerciante', 'Consumidor final']);

export const REGIONES = opt([
  'ALFONSO VEGA', 'ATANACIO MENDOZA', 'LEONARDO MAXIMO', 'MARTIN MARIN', 'OTILIO MACHUCA',
]);

export const ZONAS = opt([
  'ALICIA VALENCIA', 'ELEAZAR GARCIA', 'ENRIQUE GONZALEZ', 'ERIKA MARTINEZ',
  'GUILLERMO MARTINEZ', 'ISMAEL FERMIN', 'JAIME BALLINA', 'JESUS ROSAS', 'RODRIGO ROLDAN',
  'SILVIA ALONSO', 'VERONICA HERRERA', 'VERONICA LOPEZ',
]);

export const SUCURSALES = opt([
  'SUCURSAL ALTA TENSION', 'SUCURSAL ALTA TENSION 2', 'SUCURSAL ALTA TENSION 3',
  'SUCURSAL AMECAMECA', 'SUCURSAL ARAGÓN', 'SUCURSAL ATIZAPAN 2', 'SUCURSAL AV. 11 SUR',
  'SUCURSAL AVENIDA CENTRAL', 'SUCURSAL AZTAHUACAN', 'SUCURSAL CAZADOR',
  'SUCURSAL CAZADOR NAUCALPAN', 'SUCURSAL CHALCO', 'SUCURSAL ECATEPEC', 'SUCURSAL IGUALA 2',
  'SUCURSAL LEON 2', 'SUCURSAL MARIANO ESCOBEDO LEON', 'SUCURSAL PROFETA',
  'SUCURSAL TOLUCA 1', 'SUCURSAL TULTITLAN',
]);

export const ESTADOS = opt([
  'CDMX', 'ESTADO DE MÉXICO', 'GUANAJUATO', 'GUERRERO', 'HIDALGO', 'JALISCO', 'MICHOACAN',
  'MORELOS', 'PUEBLA', 'QUERETARO',
]);

export const ESTATUS_PLAN = opt(['Abierto', 'En proceso', 'Cerrado', 'Sin atender']);

export const USUARIOS = opt(['admin', 'renata.quiroz', 'humberto.salas', 'Dirección general']);

export const CATEGORIAS = opt([
  'La atención del personal', 'Rapidez en el servicio', 'Disponibilidad de productos',
  'Percepción de los precios', 'Orden y limpieza',
]);

export const ORIENTACIONES = opt(['Positivo', 'Neutro', 'Negativo']);

/**
 * Extremos del calendario del filtro «Rango de fechas».
 *
 * Coinciden con el universo de datos del tablero: el programa arranca en
 * febrero de 2025 y el corte es el 11/08/2026, con agosto en curso. Dejar
 * elegir fuera de esos límites sólo produciría pantallas vacías.
 */
export const RANGO_MIN = '2025-02-01';
export const RANGO_MAX = '2026-08-11';

/** Set base usado por Dashboard, Resultados, Detalle, Resultados por tienda, Close The Loop y Salud. */
export const FILTROS_BASE: Array<FilterField> = [
  { key: 'anio',        label: 'Año',             type: 'single', options: ANIOS,         plain: true },
  { key: 'mes',         label: 'Mes',             type: 'multi',  options: MESES },
  { key: 'rango',       label: 'Rango de fechas', type: 'range',  options: [], placeholder: 'dd/mm/aaaa – dd/mm/aaaa', plain: true },
  { key: 'tipoCliente', label: 'Tipo de cliente', type: 'multi',  options: TIPOS_CLIENTE, placeholder: 'TODOS' },
  { key: 'region',      label: 'Región',          type: 'multi',  options: REGIONES,      placeholder: 'TODOS' },
  { key: 'zona',        label: 'Zona',            type: 'multi',  options: ZONAS,         placeholder: 'TODOS' },
  { key: 'sucursal',    label: 'Sucursal',        type: 'multi',  options: SUCURSALES,    placeholder: 'TODOS' },
  { key: 'estado',      label: 'Estado',          type: 'multi',  options: ESTADOS,       placeholder: 'TODOS' },
];

/** Planes de acción agrega Estatus, Usuario y Categoría. */
export const FILTROS_PLANES: Array<FilterField> = [
  ...FILTROS_BASE,
  { key: 'estatus',   label: 'Estatus',   type: 'multi', options: ESTATUS_PLAN, placeholder: 'TODOS' },
  { key: 'usuario',   label: 'Usuario',   type: 'multi', options: USUARIOS,     placeholder: 'TODOS' },
  { key: 'categoria', label: 'Categoría', type: 'multi', options: CATEGORIAS,   placeholder: 'TODOS' },
];

/** Text Analytics cambia Tipo de cliente por Orientación. */
export const FILTROS_TEXT_ANALYTICS: Array<FilterField> = [
  ...FILTROS_BASE.filter((f) => f.key !== 'tipoCliente'),
  { key: 'orientacion', label: 'Orientación', type: 'multi', options: ORIENTACIONES, placeholder: 'TODOS' },
];

/** Selección por defecto: el mes en curso. */
export const FILTROS_DEFAULT: Record<string, Array<string>> = {
  anio: ['2026'],
  mes: ['Agosto'],
};
